import React from "react";
import { useNavigate } from "react-router-dom";

import FileUpload from "components/FileUpload/FileUpload";
import { Heading2 } from "widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { CREATE_PRODUCT_OFFERINGS_SCRIPT_ID } from "constants/constants";
import FileUploadsHistory from "components/FileUploadsHistory/FileUploadsHistory";

import styles from "./CreateProductOfferings.module.scss";


const handleOnClickGoBackButton = (navigate) => {
  navigate("/homePage");
};
const CreateProductOfferings = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <Heading2 heading="Create Product Offerings" />
      <FileUpload
        scriptId={CREATE_PRODUCT_OFFERINGS_SCRIPT_ID}
        uploadLabel="Upload Product Offerings"
      />
      <Heading2 heading="Recently Created Product Offerings" />
      <FileUploadsHistory scriptId={CREATE_PRODUCT_OFFERINGS_SCRIPT_ID} />
    </div>
  );
};
export default CreateProductOfferings;
